import rung from "rung/src/rung";
//import seed from "rung/src/seed";
//import Levels from "./engine/levels";
import Level from "./engine/level";
import Tile from "./engine/tile";
import Tiles from "./assets/objects/tiles";
import CalderaMap from "./assets/objects/caldera";
import Boat from "./engine/boat";
import { spawnCharacters } from "./assets/objects/characters";
import { spawnBystanders } from "./assets/objects/bystanders";
import { spawnItems } from "./assets/objects/items";

function buildCalderaMap() {
  const tiles = [];

  for (let y=0; y < CalderaMap.height; y++) {
    tiles[y] = [];
    for (let x=0; x < CalderaMap.width; x++) {
      tiles[y][x] = Tiles.Rock;
    }
  }

  for (const locationData of CalderaMap.locations) {
    const topLeft = locationData.position;
    const width = locationData.map[0].length;
    const height = locationData.map.length;

    for (let y=0; y<height; y++) {
      for (let x=0; x<width; x++) {
        const cx = x + topLeft.x;
        const cy = y + topLeft.y;
        const tileRef = locationData.map[y][x];

        if (tileRef !== null) {
          const locationTile = Tiles.get(tileRef);
          tiles[cy][cx] = locationTile;
        }
      }
    }
  }

  // TODO: define player start point in map config
  const playerStart = {
    x: 200, //200
    y: 116 //116
  }

  return {
    tiles,
    portals: {
      start: playerStart,
      exit: { y: 0, x: 0 }
    },
    features: {}
  }
}

const calderaConfig = {
  name: "Caldera",
  width: CalderaMap.width,
  height: CalderaMap.height,
  monstersMax: 0,
  monsters: {},
  drops: {},
  scene: (stage) => {
    stage.spawnEntity(Boat.create(), 257, 242);
    //stage.spawnEntity(Boat.create(), 195, 174);
    spawnCharacters(stage);
    spawnBystanders(stage);
    spawnItems(stage);
  }
}

class World {
  static generate(seed) {
    const world = new World(seed);
    world.addLevel(new Level("Caldera", buildCalderaMap, calderaConfig));
    return world;
  }

  startId;
  prevLevel;

  constructor(seed) {
    this.rng = rung();
    this.levels = new Map();
  }

  startAt(id) {
    this.startId = id;
  }

  getLevel(id) {
    return this.levels.get(id);
  }

  addLevel(level) {
    this.levels.set(level.id, level);

    // if (this.prevLevel) {
    //   level.connectPortals(this.prevLevel);
    // }
    //
    // this.prevLevel = level;
  }

  connectPortals(from, to) {
    const exitFrom = this.levels.get(from);
    const entranceTo = this.levels.get(to);

    entranceTo.entrancePortalTile = Tile.portal(
      entranceTo.entrancePortalTile.name,
      entranceTo.entrancePortalTile.desc,
      exitFrom.id,
      exitFrom.portals.exit
    );

    exitFrom.exitPortalTile = Tile.portal(
      exitFrom.exitPortalTile.name,
      exitFrom.exitPortalTile.desc,
      entranceTo.id,
      entranceTo.portals.entrance
    );
  }

  spawnStartLevel() {
    const id = this.startId ? this.startId : this.levels.keys().next().value;
    return this.spawnLevel(id);
  }

  spawnLevel(id) {
    // TODO: lazy load this using RNG
    const level = this.levels.get(id);
    return level;
  }

  getBackgroundTile(x, y) {
    return Tiles.get(CalderaMap.locations[0].map[y][x]);
  }

  getLocationBounds(id) {
    const location = CalderaMap.locations.find(loc => loc.id == id);
    return location.position;
  }
}

export default World;
